import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

type Props = {
  size?: 'small' | 'large';
  className?: string;
};

const TooltipContainer = ({ size = 'small', className, children }: PropsWithChildren<Props>) => {
  return (
    <div
      className={classNames(
        'ui-tooltip__container',
        {
          'ui-tooltip__container--small': size === 'small',
          'ui-tooltip__container--large': size === 'large',
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default TooltipContainer;
